import { GenericService } from './generic-service'

class ColecaoService extends GenericService {
  constructor () {
    super('/colecoes')
  }
}

export default new ColecaoService()
